/**
 * @generated SignedSource<<de4c602e2ae558261dd0378a3fdd6e4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductActionEnum = "product_activate" | "product_deactivate" | "product_delete" | "product_update" | "%future added value";
export type ProductRequiredFieldEnum = "customer_info" | "delivery_info" | "student_info" | "%future added value";
export type ProductShowTypeEnum = "non_registered" | "private" | "repurchase" | "store" | "upgrade" | "%future added value";
export type ProductId_productQuery$variables = {
  id: string;
};
export type ProductId_productQuery$data = {
  readonly product: {
    readonly actions: ReadonlyArray<ProductActionEnum>;
    readonly additionalDiscountAmount: number;
    readonly discountPrice: number;
    readonly id: string;
    readonly price: number;
    readonly requiredFields: ReadonlyArray<ProductRequiredFieldEnum>;
    readonly showTypes: ReadonlyArray<ProductShowTypeEnum>;
    readonly storeStuff: {
      readonly id: string;
    } | null;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProductDescriptionList_product" | "ProductUpdateDialog_product">;
  };
};
export type ProductId_productQuery = {
  response: ProductId_productQuery$data;
  variables: ProductId_productQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiredFields",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showTypes",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discountPrice",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalDiscountAmount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductId_productQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductDescriptionList_product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductUpdateDialog_product"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreStuff",
            "kind": "LinkedField",
            "name": "storeStuff",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductId_productQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreStuff",
            "kind": "LinkedField",
            "name": "storeStuff",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Stuff",
                "kind": "LinkedField",
                "name": "stuff",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductPrice",
            "kind": "LinkedField",
            "name": "productPrice",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discountPercentage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monthlyPrice",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDeleted",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0aa015944a91dbf121e5fd07b78a08bf",
    "id": null,
    "metadata": {},
    "name": "ProductId_productQuery",
    "operationKind": "query",
    "text": "query ProductId_productQuery(\n  $id: ID!\n) {\n  product(id: $id) {\n    id\n    actions\n    title\n    requiredFields\n    ...ProductDescriptionList_product\n    ...ProductUpdateDialog_product\n    storeStuff {\n      id\n    }\n    showTypes\n    price\n    discountPrice\n    additionalDiscountAmount\n  }\n}\n\nfragment ProductDescriptionList_product on Product {\n  id\n  storeStuff {\n    id\n    title\n    endAt\n    stuff {\n      id\n      title\n    }\n  }\n  showTypes\n  requiredFields\n  price\n  discountPrice\n  productPrice {\n    discountPercentage\n    monthlyPrice\n  }\n  additionalDiscountAmount\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  created\n  ...ProductStatusLabel_product\n}\n\nfragment ProductStatusLabel_product on Product {\n  status\n}\n\nfragment ProductUpdateDialog_product on Product {\n  id\n  title\n  storeStuff {\n    id\n  }\n  showTypes\n  requiredFields\n  price\n  discountPrice\n  additionalDiscountAmount\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "394ae2ea043c3fcd42ebe8995292845c";

export default node;
